import * as mainTerms from '../mainTerms';
const audience = mainTerms.Setting.audience.default;
export const SetAudience = {
    deleteAudience : {
        success: '정상적으로 삭제되었습니다.',
        error: {
            fail: '정상적으로 삭제되지 못했습니다.\n다시 시도해주세요.',
        },
    },
    retryAudienceUpload: {
        success: '정상적으로 재업로드 요청되었습니다.',
        error: {
            fail: '재업로드 요청이 정상적으로 처리되지 못했습니다.\n다시 시도해주세요.',
        },
    },
    getResponse: {
        error: {
            fail: '정상적으로 데이터를 읽어오지 못했습니다.\n페이지를 갱신해주세요.'
        }
    }
}
export const EditAudience = { 
    editing: {
        success: audience + ' 수정에 성공했습니다.',
        error: {
            getResponse: '정상적으로 데이터를 읽어오지 못했습니다.\n페이지를 갱신해주세요.',
            fail: audience + ' 수정에 실패했습니다.\n다시 시도해주세요.',
        },
    },
    new : {
        success: audience + ' 생성에 성공했습니다.',
        error: {
            fail: audience + ' 생성에 실패했습니다.\n다시 시도해주세요.',
        },
    },
    upload: {
        error: {
            fail: audience + ' 업로드에 실패했습니다.\n생성된 '+audience+'를 삭제하시고, 다시 시도해주세요.',
        },
    },
    other: {
        confirm: {
            warnIsModified: '변경 중인 내용은 저장되지 않습니다.\n정말 취소하시겠습니까?',
        },
    },
}